<script>
import { h } from 'vue';

export default {
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        return () => {
            return props.text.trim().split(/(?:\r?\n){2,}/).map(paragraph => {
                return h('p', paragraph.split(/\r?\n/).flatMap((line, i) => {
                    return i > 0 ? [h('br'), line] : line;
                }));
            });
        };
    },
};
</script>
